import { render, staticRenderFns } from "./TrainingDescriptionModal.vue?vue&type=template&id=2b071438&"
import script from "./TrainingDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./TrainingDescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports